import { TaiLieu } from "../nhanvien/TaiLieu";

export class ToBan {
    "id": number;
    "ten": string;
    "soQuyetDinh": string;
    "ngayKyQuyetDinh": Date | null;
    "ngayBatDau": Date | null;
    "ngayKetThuc": Date | null;
    "dsNhanVien": Array<NhanVienTheoToBan>;
    "moTa": string;
    "trangThai": number;
    "dsTaiLieu": Array<TaiLieu>;
}

export class ToBanRequest {
    "files": Array<any>;
    "id": number | null;
    "ten": string;
    "soQuyetDinh": string;
    "ngayKyQuyetDinh": Date | null;
    "ngayBatDau": Date | null;
    "ngayKetThuc": Date | null;
    "dsNhanVien": Array<NhanVienTheoToBanRequest>;
    "moTa": string;
    "trangThai": number;
    "idsTaiLieuToBanXoa": Array<number>;
}

export class TimKiemToBanResponse {
    "id": number;
    "ten": string;
    "soQuyetDinh": string;
    "ngayKyQuyetDinh": Date | null;
    "ngayBatDau": Date | null;
    "ngayKetThuc": Date | null;
    "soLuongNhanVien": number;
    "trangThai": number;
    "chucDanh": string;
    "dsNhanVien": Array<NhanVienTheoToBan>;
}

export class NhanVienTheoToBan {
    "id": number;
    "hoTen": string;
    "tenChucVu": string;
    "tenDonVi": string;
    "idNhanVien": number;
    "chucDanh": string;
    "idToBan": number;
}

export class NhanVienTheoToBanRequest {
    "idNhanVien": number;
    "chucDanh": string;
}